import { type TranslationTree } from '@/i18n/types';

export const messages = {
  createTitle: 'Nova oferta',
  editTitle: 'Editar oferta',
  subtitle:
    'A equipe Bodyprint revisa cada oferta e decide para quem e onde ela aparece no app, criando a campanha.',
  reviewNoteTitle: {
    draft: 'Motivo da recusa',
    changes_requested: 'A equipe Bodyprint pediu um ajuste',
  },
  optional: 'Opcional',
  sections: {
    image: 'Imagem',
    text: 'Texto',
    benefit: 'O que o atleta ganha',
    actions: 'Botões',
    locations: 'Onde vale',
    audience: 'Público e período desejados',
  },
  textHint: 'Direto e sem promessa de saúde, preço enganoso ou urgência ("só hoje").',
  actionsHint: 'Até 2',
  locationsRequired: 'Obrigatório com "Como chegar"',
  audienceHint:
    'É um pedido. A Bodyprint decide o público final, onde a oferta aparece e por quanto tempo.',
  title: 'Título',
  body: 'Texto',
  desiredAudienceText: 'Para quem',
  desiredAudiencePlaceholder: 'Ex.: corredores que treinam para maratona, no Sudeste',
  desiredStartsAt: 'De',
  desiredEndsAt: 'Até',
  cancel: 'Cancelar',
  discard: 'Descartar alterações',
  saveDraft: 'Salvar rascunho',
  saveChanges: 'Salvar alterações',
  saveAndSubmit: 'Salvar e enviar para análise',
  saveAndResubmit: 'Salvar e reenviar para análise',
  submitLocked: 'O envio para análise fica liberado quando a conta for aprovada.',
  saved: 'Oferta salva',
  submitted: 'Oferta enviada para análise',
  saveError: 'Não foi possível salvar a oferta. Tente novamente',
} satisfies TranslationTree;
